import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {GetTreeFolderPathApiResponse} from '../types';

const getSparePartsCatalogMock = {
  treeFolder: {
    id: 'fbc98755-466a-40f9-83cc-989f0f4ab174',
    label: 'Uncategorized',
    level: 0,
    actions: ['addFolder', 'addRelation'],
  },
};

const getSparePartsCatalogResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/core/v1/tree-folder/spare-parts-catalog/*', () =>
      HttpResponse.json(getSparePartsCatalogMock)
    )
  );

const getTreeFolderPathMock: GetTreeFolderPathApiResponse = {
  treeFolder: {
    id: 'fbc98755-466a-40f9-83cc-989f0f4ab174',
    label: 'Uncategorized',
    pathName: 'Uncategorized',
  },
};

const getTreeFolderPathResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/core/v1/tree-folder/leaf/*', () => HttpResponse.json(getTreeFolderPathMock))
  );

export const metadaTreeFolderApiMock = {
  getSparePartsCatalogMock,
  getSparePartsCatalogResponseInterceptor,
  getTreeFolderPathMock,
  getTreeFolderPathResponseInterceptor,
};
